require('./cardModifyLimitInformativeSection.scss');
const PropTypes = require('prop-types');
//@vendor
const React = require('react');
//@commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { FormattedText } = require('core/i18n').i18n;
//@utilities
const { getFormattedString } = require('utilities/currencyHelper');

class CardModifyLimitInformativeSection extends React.Component {
    buildInformativeList() {
        const { immCard, newLimit } = this.props;
        const currentLimit = getFormattedString({
            amount: immCard.getIn(['limit', 'amount']),
            currency: immCard.getIn(['limit', 'currency']),
            decimalsLength: 0
        });

        const informativeItems = [
            <OKInformativeListItem
                key="cardModifyLimitInformativeSection-contractNumber"
                title="cardModifyLimitInformativeSection-contractNumber"
                bodyText={immCard.get('fullContractNumber')}
            />,
            <OKInformativeListItem
                key="cardModifyLimitInformativeSection-cardHolder"
                title="cardModifyLimitInformativeSection-cardHolder"
                bodyText={immCard.get('titularName')}
            />,
            <OKInformativeListItem
                key="cardModifyLimitInformativeSection-currentLimit"
                title="cardModifyLimitInformativeSection-currentLimit"
                bodyText={currentLimit}
            />
        ];

        if (newLimit) {
            const formattedNewLimit = getFormattedString({
                amount: newLimit.amount,
                currency: newLimit.currency,
                decimalsLength: 0
            });

            informativeItems.push(
                <OKInformativeListItem
                    key="cardModifyLimitInformativeSection-newLimit"
                    title="cardModifyLimitInformativeSection-newLimit"
                    bodyText={formattedNewLimit}
                />
            );
        }

        return (
            <OKInformativeList columns={2}>
                {informativeItems}
            </OKInformativeList>
        );
    }

    render() {
        const { operativeName, notShowScript } = this.props
        const InformativeList = this.buildInformativeList();

        return (
            <section className="card-modify-limit-informative-section">
                <header className="card-modify-limit-informative-section__header">
                    <FormattedText value={this.props.titleKey} />
                </header>
                <ContactCenterRender>
                    {
                        operativeName && !notShowScript
                        &&
                        <ConfirmationScript
                            operative={operativeName}
                            confirmationType={CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY}
                        />
                    }
                </ContactCenterRender>
                <div className="card-modify-limit-informative-section__body">
                    {InformativeList}
                </div>
            </section>
        );
    }
}

CardModifyLimitInformativeSection.propTypes = {
    immCard: PropTypes.object.isRequired,
    titleKey: PropTypes.string.isRequired,
    newLimit: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired,
    operativeName: PropTypes.string
};

CardModifyLimitInformativeSection.defaultProps = {
    newLimit: false
};

module.exports = CardModifyLimitInformativeSection;